
const herobg1 = require("../assets/herobg1.png");
const herobg2 = require("../assets/herobg2.png");
const herobg3 = require("../assets/herobg3.jpg");
const herobg4 = require("../assets/herobg4.jpg");


export {herobg1, herobg2, herobg3,logo,herobg4};

const logo = require("../assets/logo.png");

const feature = {
    feature1: require("../assets/feature1.png"),
    feature2: require("../assets/feature2.png"),
    feature3: require("../assets/feature3.png"),
    feature4: require("../assets/feature4.png"),
  };
  
export default feature;


const product_categories = {
    category1: require("../assets/onion-categcode.png"),
    category2: require("../assets/turmeric-categ.png"),
    category3: require("../assets/chilly-categ.png"),
}
export {product_categories};


// const countries_flags = [
//     { src: require("../assets/in.svg"), alt: "India" },
//     { src: require("../assets/ca.svg"), alt: "Canada" },
//     { src: require("../assets/us.svg"), alt: "USA" },
//     { src: require("../assets/sg.svg"), alt: "Singapore" },
//     { src: require("../assets/gb.svg"), alt: "United Kingdom" },
//     { src: require("../assets/au.svg"), alt: "Australia" },
//     { src: require("../assets/ae.svg"), alt: "UAE" },
//   ];
  
//   export {countries_flags};
  